import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main" }

import request from "../../common/request";
import { useRouter } from "vue-router";
import { computed, onMounted } from "vue";
import { ref, reactive, toRaw } from "vue";
import type { UploadProps } from "ant-design-vue";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import { Dayjs } from 'dayjs';

import { operateLogs } from "@/common/logs";
import { getLanguage, getChineseFt } from "@/common/translate";
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import zhHK from "ant-design-vue/es/locale/zh_HK";
import { transformBeiJingDate, transformLocalDate } from "../../common/tools";


export default /*@__PURE__*/_defineComponent({
  __name: 'DataChangesLogs',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const formRef = ref();
let factoryId = "";
/**操作日志记录 */
operateLogs('Access operative logging');
let language: any = ref('English')
const getLang = () => {
   language.value = 'English'
}
getLang();



/**操作日志记录 */
const formState = ref({
  keyWord: "",
  date: [],
  skip: 1,
  take: 15,
  total: 0,
});
const pagination = computed(() => ({
  total: formState.value.total,
  current: formState.value.skip,
  pageSize: formState.value.take,
}));

const dataSource = ref([]);
const columns = [
  {
    title: getLanguage("操作人") ,
    dataIndex: "userName",
    align: "center"
  },
  {
    title: getLanguage("操作路由"),
    dataIndex: "router",
    align: "center"
  },
  {
    title: getLanguage("操作详情"),
    dataIndex: "desc",
    align: "center"
  },
  {
    title: getLanguage("时间"),
    dataIndex: "date",
    align: "center"
  }
];
const handleTableChange = (pagination: any, filters: any, sorter: any) => {
  console.log(`当前页码：${pagination.current}，每页显示条数：${pagination.pageSize}`);
  // 处理分页数据
  formState.value.skip = pagination.current
  search();
}
// 查询
const search = () => {
  var params = {
    skip: formState.value.skip,
    take: formState.value.take,
  }
  if (formState.value.date && formState.value.date.length) {
    params.begin = transformBeiJingDate(formState.value.date[0])
    params.end = transformBeiJingDate(formState.value.date[1])
  } else {
    delete params.begin
    delete params.end
  }
  const config = {
    params: params,
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/logs/change", config).then((res: any) => {
    if (res) {
      dataSource.value = res.data.list;
      formState.value.total = res.data.count
    }
  });
};

// 在组件加载完成后执行一些操作
onMounted(async () => {
  search();
});

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], 'days') > 30;
  const tooEarly = dates.value[1] && current.diff(dates.value[1], 'days') > 30;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};
const getLocale = () => {
  let data = zhCN
  
  if(language.value === 'English') {
    data = enUS
  }
  if(language.value === 'Chinese_ft') {
    data = zhHK
  }
  return data
}


return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: getLocale()
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_layout_content, { style: {"padding":"0 20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: _unref(getLanguage)('时间')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: formState.value.date,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.value.date) = $event)),
                      style: {"width":"400px"},
                      "show-time": "",
                      format: "YYYY/MM/DD HH:mm:ss",
                      valueFormat: "YYYY/MM/DD HH:mm:ss",
                      "disabled-date": disabledDate,
                      onCalendarChange: onCalendarChange
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(getLanguage)('搜索')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_table, {
                bordered: "",
                emptyText: '暂无数据',
                columns: columns,
                "data-source": dataSource.value,
                pagination: pagination.value,
                loading: loading.value,
                onChange: handleTableChange,
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'desc')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(language) === 'Chinese_ft' ?  _unref(getChineseFt)(text) : text), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'date')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(transformLocalDate)(text)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "pagination", "loading"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})